import React from 'react';
import AMC from "./AMC";
import {ROUTER} from "./AMCRouter";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone } from '@fortawesome/free-solid-svg-icons'

export default class AMCCloneButton extends React.Component {
	onClone() {
		let { item, onClone, callback, link } = this.props;
		if (onClone) {
			return onClone(item.uri);
		}
		AMC.clone(item.uri, function(err, newmodel_uri) {
			if (!err) {
				if (link) {
					ROUTER.pushRoute(link + newmodel_uri);
				}
			}
			if (callback) {
				callback(err, newmodel_uri);
			}
		});
	}
	render() {
		let { item } = this.props;
		return (
			<div className="HScoreButton" onClick={this.onClone.bind(this)}>
			<div className="HScoreButtonLabel" aria-label="Clone this thing" title={"Clone and edit copy of this " + item.kind}>
				<FontAwesomeIcon icon={faClone} />
				Clone
			</div>
			<div className="HScoreButtonCount" aria-label={(item.clones || 0) + " clones of this thing so far"}>{item.clones || 0}</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCCloneButton.js